module.exports = __webpack_public_path__ + "static/media/logo.d949edf5.png";